module.exports = __webpack_public_path__ + "img/Desk Stationeryd13.5be1fcf4.jpg";